import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from 'context/auth'
import { useAgency } from 'context/agency'
import { useTranslation } from 'context/translation'
import ClickOutSide from 'hooks/click-outside'

const getInitials = (name) => {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/)
  const first = parts[0]?.[0] || ''
  const last = parts.length > 1 ? parts[parts.length - 1][0] : ''
  return (first + last).toUpperCase()
}

function SidebarUser() {
  const { currentUser, logout } = useAuth()
  const { agency } = useAgency()
  const { t, isRTL } = useTranslation()
  const [open, setOpen] = useState(false)

  const name = currentUser?.fullname || currentUser?.firstname || currentUser?.email || ''
  const brandName =
    agency?.name ||
    agency?.basic_info?.business_name ||
    agency?.location_config?.brand_name ||
    t('Walaa')

  return (
    <div className='relative px-2 py-3 mt-2 border-t border-white/20'>
      <div className='flex items-center gap-3'>
        {/* Avatar */}
        <div className='flex-shrink-0 h-9 w-9 rounded-full bg-white/20 text-white grid place-items-center text-sm font-semibold'>
          {getInitials(name)}
        </div>

        {/* Brand + user name */}
        <div className='min-w-0 flex-1'>
          <p className='text-xs text-white/70 truncate'>{brandName}</p>
          <p className='text-sm font-medium text-white truncate'>{name}</p>
        </div>

        {/* 3-dot menu */}
        <ClickOutSide onClickOutside={() => setOpen(false)} className='relative'>
          <button
            type='button'
            aria-label={t('User menu')}
            onClick={() => setOpen((v) => !v)}
            className='text-white/80 hover:text-white p-1 rounded-md hover:bg-white/10'
          >
            <svg width='20' height='20' viewBox='0 0 24 24' fill='currentColor'>
              <circle cx='12' cy='5' r='2' />
              <circle cx='12' cy='12' r='2' />
              <circle cx='12' cy='19' r='2' />
            </svg>
          </button>

          {open && (
            <div
              className={`absolute bottom-10 z-50 w-40 bg-white rounded-lg shadow-lg py-1 ${
                'end-0'
              }`}
            >
              <Link
                to='./settings/generalinfo'
                onClick={() => setOpen(false)}
                className='block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
              >
                {t('Profile')}
              </Link>
              <button
                type='button'
                onClick={() => {
                  setOpen(false)
                  logout()
                }}
                className={`block w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100 ${
                  'text-start'
                }`}
              >
                {t('Logout')}
              </button>
            </div>
          )}
        </ClickOutSide>
      </div>
    </div>
  )
}

export default SidebarUser
